import { routes } from '@/types/routes';
import { redirect, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/context/authContext';
import { useEffect } from 'react';
import type { AuthTokens } from '@/api/mutations/auth';

// Narrow, permissive shape matching the part of the TanStack beforeLoad context we care about.
interface AuthBeforeLoadParam {
  context?: {
    auth?: {
      isLoading?: boolean;
      tokens?: AuthTokens | null;
    };
  };
}

export function authBeforeLoad({ context }: AuthBeforeLoadParam): void {
  const isLoading = !!context?.auth?.isLoading;
  const tokens = context?.auth?.tokens;

  if (!isLoading && !tokens) {
    redirect({
      to: routes.login,
      replace: true,
      throw: true,
    });
  }
}

export function useRedirectToLoginIfNoAuth() {
  const { tokens, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (tokens || isLoading) return;
    void navigate({ to: routes.login });
  }, [ tokens, isLoading, navigate ]);
}
